export const XLS = 'xls'
export const CSV = 'csv'
export const DEFAULT_EXPORT_FORMATS = [XLS, CSV]
